// Admin-only rebind of an external call-center account (#1261). PATCH
// /call-center-agents/:userId/binding.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CallCenterAccountSchema,
  type CallCenterAccount,
  type UpdateCallCenterAccountBindingInput,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';

export function useUpdateCallCenterBinding(userId: string) {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<CallCenterAccount, unknown, UpdateCallCenterAccountBindingInput>({
    mutationFn: (input) =>
      client.patch<CallCenterAccount>(
        `/call-center-agents/${userId}/binding`,
        input,
        {},
        CallCenterAccountSchema,
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['call-center-agents', 'list'] }),
  });
}
